import { usePerformance } from '@/hooks/usePerformance';
import { getMainUserState } from '@/modules/main/selector';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { BJRobotProp, TmpBJRobot } from './TmpBJRobot';
export const FPSBar = () => {
    const { fps, isFpsRunning, averageFPS } = usePerformance();
    const { IsInternalTest } = useSelector(getMainUserState);
    const [startBJRobot, setStartRobot] = useState<boolean>(false);
    const [data, setData] = useState<BJRobotProp>();
    useEffect(() => {
        const input = window.sessionStorage.getItem('bjRobot');
        console.log('????', IsInternalTest, input);
        if (IsInternalTest && input) {
            setStartRobot(true);
            const tmp = JSON.parse(input);
            setData(tmp);
            console.log('???? start robot', tmp);
        }
    }, [IsInternalTest]);
    // const { fps, isFpsRunning, averageFPS } = useContext(LiteUIContext);
    const color = useMemo(() => {
        if (fps < 20) {
            return 'red';
        }
        if (fps < 30) {
            return 'orange';
        }
        if (fps < 40) {
            return 'yellow';
        }
        return 'green';
    }, [fps]);
    const averageColor = useMemo(() => {
        if (!averageFPS) {
            return '';
        }
        if (averageFPS < 15) {
            return 'red';
        }
        if (averageFPS < 30) {
            return 'orange';
        }
        if (averageFPS < 40) {
            return 'yellow';
        }
        return 'green';
    }, [averageFPS]);
    return isFpsRunning ? (
        <div
            style={{
                pointerEvents: 'none',
                position: 'absolute',
                top: '0px',
                zIndex: 10000,
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                lineHeight: 1,
            }}
        >
            <div
                style={{
                    color: color,
                }}
            >{`${fps}fps`}</div>
            {startBJRobot && data && <TmpBJRobot {...data} />}
            {averageFPS && (
                <div
                    style={{
                        color: averageColor,
                    }}
                >{`${averageFPS}fps`}</div>
            )}
        </div>
    ) : (
        <></>
    );
};
